var _title, _path, _rect, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "null",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", {
    stroke: "null"
  }, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    id: "svg_4",
    d: "m440.79,144.85792l0.76394,0l0.23606,-0.54067l0.23606,0.54067l0.76394,0l-0.61804,0.33415l0.23608,0.54067l-0.61804,-0.33416l-0.61804,0.33416l0.23608,-0.54067l-0.61804,-0.33415z",
    strokeWidth: 0,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    id: "svg_5",
    d: "m446.76,77.45471l0.56913,0l0.17587,-0.38197l0.17587,0.38197l0.56913,0l-0.46044,0.23607l0.17588,0.38197l-0.46044,-0.23607l-0.46044,0.23607l0.17588,-0.38197l-0.46044,-0.23607z",
    strokeWidth: 0,
    fill: "#000000"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    id: "svg_7",
    height: 383,
    width: 400,
    y: -19,
    x: -20,
    strokeWidth: 0,
    fill: "#DDDDDD"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "'Truculenta'",
    fontSize: 30,
    id: "svg_8",
    y: 182,
    x: 60,
    strokeWidth: 0,
    stroke: "#000",
    fill: "#000000"
  }, "\u0639\u06A9\u0633\u06CC \u0631\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u06A9\u0646\u06CC\u062F"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt);
export default __webpack_public_path__ + "static/media/Alt.59d85ee256a01e8b81dc61b966114870.svg";
export { ForwardRef as ReactComponent };